import { Injectable } from '@angular/core';
import { filter, Observable, take } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppSettingsService, AuthFacade, FeatureService, ShopperService } from '@woolworthsnz/styleguide';
import { EverydayRewardsFacade } from '../+state';
import { ContextResponse } from '@woolworthsnz/trader-api';

@Injectable({
	providedIn: 'root',
})
export class EDRStartupService {
	constructor(
		private appSettingsService: AppSettingsService,
		private shopperService: ShopperService,
		private edrFacade: EverydayRewardsFacade,
		private authFacade: AuthFacade,
		private featureService: FeatureService
	) {}

	/**
	 * Load the global store state on application init
	 */
	public init(): void {
		const isLoggedIn$: Observable<boolean> = this.appSettingsService.useSSU()
			? this.authFacade.isLoggedIn$
			: this.shopperService.state$.pipe(map((s) => Boolean(s.isLoggedIn)));

		isLoggedIn$
			.pipe(
				filter(Boolean),
				switchMap(() =>
					this.featureService.isEnabled(ContextResponse.EnabledFeaturesEnum.EnableEdrRewardMessages)
				),
				take(1)
			)
			.subscribe((isRewardMessagesEnabled: boolean) => {
				this.edrFacade.fetchEdrBalance();
				this.edrFacade.fetchBoostOffersCount();

				if (isRewardMessagesEnabled) {
					this.edrFacade.fetchRewardMessages();
				}
			});
	}
}
